import { tns } from 'tiny-slider/src/tiny-slider';

class LogosSlider {
	constructor(el) {
		this.el = el;

		const sliderOuter = this.el.closest('.block-logos__slider-outer');
		const prevButton = sliderOuter?.querySelector('.block-logos__slider-prev');
		const nextButton = sliderOuter?.querySelector('.block-logos__slider-next');
		const hasControls = prevButton && nextButton;

		// Store original logo links before Tiny Slider creates cloned slides.
		const logoLinks = Array.from(
			this.el.querySelectorAll('.block-logos__logo-link')
		);

		const logosSlider = tns({
			container: this.el,
			items: 1.5,
			responsive: {
				641: {
					items: 3
				},
				1025: {
					items: 5
				},
			},
			autoplay: false,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			controls: !!hasControls,
			prevButton: prevButton || false,
			nextButton: nextButton || false,
			gutter: 20
		});

		if (prevButton && nextButton) {
			prevButton.setAttribute('tabindex', '0');
			nextButton.setAttribute('tabindex', '0');
		}

		// Keep cloned Tiny Slider links out of the tab order.
		this.el.querySelectorAll('.block-logos__logo-link').forEach((link) => {
			link.setAttribute('tabindex', '-1');
		});

		// Original logo links remain keyboard accessible.
		logoLinks.forEach((link, index) => {
			link.setAttribute('tabindex', '0');

			link.addEventListener('focus', () => {
				logosSlider.goTo(index);
			});
		});

		return logosSlider;
	}
}

export default LogosSlider;